var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Link } from "react-router-dom";
import { Button, Dimmer, Loader, Message, Modal, Table } from "semantic-ui-react";
import { AppPaths } from "../AppConfig";
import { getWithAuthn } from "../RequestHelpers";
var BufferTracking = /** @class */ (function (_super) {
    __extends(BufferTracking, _super);
    function BufferTracking(props) {
        var _this = _super.call(this, props) || this;
        _this.renderBufferTable = function (resp) {
            var cols = resp.allBufferCategories.length * 2 + 2;
            var width = 100.0 / cols;
            var colStyle = { width: width + "%" };
            return React.createElement(React.Fragment, null,
                React.createElement("p", null, "Aliquot counts per volume."),
                React.createElement(Table, { striped: true, celled: true },
                    React.createElement(Table.Header, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.HeaderCell, { style: colStyle }),
                            resp.allBufferCategories.map(function (category, index) {
                                return React.createElement(Table.HeaderCell, { style: colStyle, key: "hybridization-" + index },
                                    "Hybridization (",
                                    category.label,
                                    ")");
                            }),
                            React.createElement(Table.HeaderCell, { style: colStyle }, "Wash"),
                            resp.allBufferCategories.map(function (category, index) {
                                return React.createElement(Table.HeaderCell, { style: colStyle, key: "amplification-" + index },
                                    "Amplification (",
                                    category.label,
                                    ")");
                            }))),
                    React.createElement(Table.Body, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Total (mL)"),
                            resp.allBufferCategories.map(function (category, index) {
                                return React.createElement(Table.Cell, { key: "hybridization-" + index }, resp.hybridization.get(category.id).totalVolMl);
                            }),
                            React.createElement(Table.Cell, null, resp.wash.totalVolMl),
                            resp.allBufferCategories.map(function (category, index) {
                                return React.createElement(Table.Cell, { key: "amplification-" + index }, resp.amplification.get(category.id).totalVolMl);
                            })),
                        resp.allAliquotVolumes.map(function (aliquot, aliquotIndex) {
                            return React.createElement(Table.Row, { key: aliquotIndex },
                                React.createElement(Table.Cell, null,
                                    aliquot,
                                    " mL"),
                                resp.allBufferCategories.map(function (category, index) {
                                    return React.createElement(React.Fragment, { key: "hybridization-" + index }, _this.renderCountCell(resp.hybridization.get(category.id), aliquot));
                                }),
                                _this.renderCountCell(resp.wash, aliquot),
                                resp.allBufferCategories.map(function (category, index) {
                                    return React.createElement(React.Fragment, { key: "amplification-" + index }, _this.renderCountCell(resp.amplification.get(category.id), aliquot));
                                }));
                        }))));
        };
        _this.renderCountCell = function (summary, aliquot) {
            var nonZero = summary.aliquotsPerOrder
                .filter(function (perOrder) { return perOrder.aliquotCounts.get(aliquot) > 0; });
            var modal = React.createElement(Modal, { trigger: React.createElement(Button, { icon: 'eye', size: 'mini' }), closeIcon: true },
                React.createElement(Modal.Header, null, "Orders with this aliquot"),
                React.createElement(Modal.Content, null,
                    React.createElement("ul", null, nonZero
                        .map(function (perOrder, index) {
                        return React.createElement("li", { key: index },
                            "Order ",
                            React.createElement(Link, { to: AppPaths.ADMIN_ORDER_BASE + "/" + encodeURIComponent(perOrder.orderId) }, perOrder.orderId),
                            React.createElement("ul", null, Array.from(perOrder.aliquotCounts.entries())
                                .filter(function (pair) { return pair[1] > 0; })
                                .map(function (pair, aliquotIndex) {
                                return React.createElement("li", { key: aliquotIndex },
                                    pair[0],
                                    "mL \u00D7 ",
                                    pair[1]);
                            })));
                    }))));
            var count = summary.aliquotTotalCounts.get(aliquot);
            return count > 0 ? React.createElement(Table.Cell, null,
                count,
                "\u00A0",
                modal) : React.createElement(Table.Cell, null);
        };
        _this.loadData = function () {
            _this.setState({ loading: true }, function () {
                getWithAuthn('/admin/tracking/buffers')
                    .then(function (resp) {
                    if (resp.ok) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            error: false,
                            loading: false,
                            response: {
                                hybridization: new Map(resp.hybridization.map(function (category) {
                                    return [category.category, jsonBufferSummaryToBufferSummary(category.summary)];
                                })),
                                wash: jsonBufferSummaryToBufferSummary(resp.wash),
                                amplification: new Map(resp.amplification.map(function (category) {
                                    return [category.category, jsonBufferSummaryToBufferSummary(category.summary)];
                                })),
                                allAliquotVolumes: resp.allAliquotVolumes,
                                allBufferCategories: resp.allBufferCategories
                            }
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load report: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            error: false
        };
        return _this;
    }
    BufferTracking.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { className: 'amplifier-label-report' },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            this.state.error &&
                React.createElement(Message, { negative: true }, "Report could not be loaded."),
            this.state.response && this.renderBufferTable(this.state.response));
    };
    BufferTracking.prototype.componentDidMount = function () {
        this.loadData();
    };
    return BufferTracking;
}(React.PureComponent));
export default BufferTracking;
;
var jsonBufferSummaryToBufferSummary = function (json) {
    return {
        aliquotTotalCounts: new Map(Object.entries(json.aliquotTotalCounts)
            .map(function (pair) { return [parseInt(pair[0], 10), pair[1]]; })),
        aliquotsPerOrder: json.aliquotsPerOrder.map(function (perOrder) {
            return {
                orderId: perOrder.orderId,
                aliquotCounts: new Map(perOrder.aliquotCounts.map(function (count) { return [count.aliquotMl, count.count]; }))
            };
        }),
        totalVolMl: json.totalVolMl
    };
};
//# sourceMappingURL=BufferTracking.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/BufferTracking.js
// module id = 1452
// module chunks = 0